import openNotification from './NotificationComponent';

export default openNotification;
